<template>
	<div class="container mt-5">
		<h2>Manage Email Preferences</h2>
		<div class="mb-3">
			<button class="btn btn-primary me-2" @click="selectAll">
				Select All
			</button>
			<button class="btn btn-secondary" @click="selectNone">Select None</button>
		</div>
		<form @submit.prevent="updatePreferences">
			<div class="form-check mb-3">
				<input
					type="checkbox"
					class="form-check-input"
					id="marketing"
					v-model="preferences.marketing"
					:checked="preferences.marketing" />
				<label class="form-check-label" for="marketing"
					>Receive Promotional Emails</label
				>
			</div>
			<div class="form-check mb-3">
				<input
					type="checkbox"
					class="form-check-input"
					id="weeklyUpdates"
					v-model="preferences.weeklyUpdates"
					:checked="preferences.weeklyUpdates" />
				<label class="form-check-label" for="weeklyUpdates"
					>Receive Weekly Updates</label
				>
			</div>
			<div class="form-check mb-3">
				<input
					type="checkbox"
					class="form-check-input"
					id="systemNotifications"
					v-model="preferences.systemNotifications"
					:checked="preferences.systemNotifications" />
				<label class="form-check-label" for="systemNotifications"
					>Receive System Notifications</label
				>
			</div>
			<!-- <div class="form-check mb-3">
				<input
					type="checkbox"
					class="form-check-input"
					id="airDropNotification"
					v-model="preferences.airDropNotification"
					:checked="preferences.airDropNotification"
					 />
				<label class="form-check-label" for="airDropNotification"
					>Receive AirDrop Notifications</label
				>
			</div> -->
			<button type="submit" class="btn btn-success">Update Preferences</button>
		</form>
	</div>
</template>

<script setup>
	import { ref, onMounted } from "vue"
	import { useRoute, useRouter } from "vue-router"
	import Swal from "sweetalert2"

	const route = useRoute()
	const router = useRouter()
	const preferences = ref({
		weeklyUpdates: true,
		marketing: true,
		airDropNotification: true,
		systemNotifications: true,
	})

	const selectAll = () => {
		preferences.value.marketing = true
		preferences.value.weeklyUpdates = true
		preferences.value.airDropNotification = true
		preferences.value.systemNotifications = true
	}

	const selectNone = () => {
		preferences.value.marketing = false
		preferences.value.weeklyUpdates = false
		preferences.value.airDropNotification = false
		preferences.value.systemNotifications = false
	}

	const updatePreferences = async () => {
		const token = route.query.token
		const res = await fetch(`/api/update-email-preferences`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				token,
				preferences: preferences.value,
			}),
		})
		if (res.ok) {
			Swal.fire({ icon: "success", title: "Email Prefrences Updated" })
		} else {
			Swal.fire({
				icon: "error",
				title: "Something happened on the server, please try again later.",
			})
		}
	}

	onMounted(async () => {
		const token = route.query.token ?? null
		// console.log(token)
		const res = await fetch(
			`/api/get-email-preferences?token=${encodeURIComponent(token)}`
		)
		const data = await res.json()
		if (!res.ok) {
			router.push({ name: "home" })
		} else {
			preferences.value = data
		}
	})
</script>

<style scoped>
	.container {
		max-width: 600px;
		margin: auto;
	}
</style>
